import { AGENT_PROFILE_PAGE, PEOPLE_AGENT_PATH_PATTERN } from '@townsquare/config/routes';
import { createGlobalRoute } from '@townsquare/router/create-route';
import { GlobalHomePageRoute } from '@townsquare/router/route-types';

export const agentProfileRoute: GlobalHomePageRoute = createGlobalRoute({
	exact: true,
	name: AGENT_PROFILE_PAGE,
	path: PEOPLE_AGENT_PATH_PATTERN,
	subproduct: 'townsquare-people-team-directory',
	layout: 'expanded',
});
